import { Box } from "@mui/material";
import { isNil } from "lodash";
// import BkLock from "../assets/common/bk_lock.png";
import CheckMark from "../assets/common/check-mark.png";
import Item, { ItemProps } from "./Item";

interface SongProps extends ItemProps {
    isLocked: boolean
    display: "vertical" | "horizontal" | "double line horizontal"
}

const Song = (props: SongProps) => {

    let { isLocked, ...fwdProps } = props;

    const checkSong = () => {
        if (!isNil(props.item) && !isNil(props.updateItem))
            props.updateItem({ ...props.item, isChecked: !props.item?.isChecked })
    }
    return <Box display="flex" position="relative" width="32px" height="32px"  justifyContent="center" flexGrow={1} marginBottom={"10px"} sx={{backgroundColor: props.isLocked ? "red" : "inherit"}}>
        <Item {...fwdProps} onRightClick={(e) => { e.preventDefault(); checkSong() }} displayChildItem />
        {props.isLocked && (props.display === "horizontal" || props.display === "double line horizontal") &&
            <Box component="div" display={"flex"} position="absolute" bottom="-25px" justifyContent={"center"} boxSizing="content-box" onContextMenu={(e) => e.preventDefault()}>
                {/* <img src={BkLock} alt="lock" width="30px" height="30px" /> */}
            </Box>
        }
        {props.isLocked && props.display === "vertical" &&
            <Box component="div" display={"flex"} position="absolute" right="-25px" top="5px" justifyContent={"center"} boxSizing="content-box" onContextMenu={(e) => e.preventDefault()}>
                {/* <img src={BkLock} alt="lock" width="30px" height="30px" /> */}
            </Box>
        }
        {props.item?.isChecked && <Box display="flex" position="absolute" top="-5px" right="-10px" onContextMenu={(e) => e.preventDefault()}>
            <img src={CheckMark} alt="check" width="20px" height="20px" />
        </Box>}
        {!props.isLocked && <Box component={"div"} height="20px" width={"20px"} />}
    </Box>



}

export default Song